export default __webpack_public_path__ + "static/media/D200_RoHS.d4fb9898.pdf";